/**
 * @var service.ready
 * @var service.banners
 * @param grecaptcha
 * @param variables {{ recaptcha: object, profiles: object }}
 */
const VideosController =  ['$scope', '$rootScope', '$http', '$modules', '$httpParamSerializerJQLike', function($scope, $rootScope, $http, $modules, $httpParamSerializerJQLike) {

    $modules.add('playerDownloads');
    $modules.add('playlists');
    $modules.add('suggestPornstars');
    $modules.add('playerReport');

    $scope.csrfToken = {};
    $scope.loading = false;

    $scope.versionDesktop = !!$scope.device.desktop;

    $scope.actions = {
        like: function () {
            if ( $scope.loading === true ) {
                return false;
            }
            $scope.loading = true;
            $http.get( $scope.service.video.links.like, {withCredentials: true}).then(function(response) {
                // Reset dislikes
                $scope.service.video.dislikes.disliked = false;
                $scope.service.video.dislikes.counter = response.data.dislikes;

                $scope.service.video.likes.counter = response.data.likes;
                $scope.service.video.likes.liked = !$scope.service.video.likes.liked;
                $scope.loading = false;
            });
        },
        dislike: function () {
            if ( $scope.loading === true ) {
                return false;
            }
            $scope.loading = true;
            $http.get( $scope.service.video.links.dislike, {withCredentials: true}).then(function(response) {
                // Reset likes
                $scope.service.video.likes.liked = false;
                $scope.service.video.likes.counter = response.data.likes;

                $scope.service.video.dislikes.counter = response.data.dislikes;
                $scope.service.video.dislikes.disliked = !$scope.service.video.dislikes.disliked;

                $scope.loading = false;
            });
        },
        comment: function ( hash ) {
            let element = document.getElementById('comments');
            let value = element.offsetTop;
            while ( element = element.offsetParent ) {
                value += element.offsetTop;
            }
            //let headerHeight = document.getElementById('-h').offsetHeight;
            //  - (headerHeight + 15)
            window.scrollTo({ top: value, behavior: 'smooth' });
        },
        download: function () {
            if (  $scope.service.video.download.available === false ) {
                $rootScope.showLoginPopup = true;
                $rootScope.loadLoginPopup = true;
                return false;
            } else {
                $modules.toggle('playerDownloads');
            }
        },
        async favorite() {
            if ($scope.service.video.playlists.available === false) {
                $rootScope.showLoginPopup = true;
                $rootScope.loadLoginPopup = true;
                return;
            }
            try {
                $scope.loading = true;

                const params = {
                    [$scope.service.video.csrfToken.name]: $scope.service.video.csrfToken.value,
                    movie_id: $scope.service.video.id
                };
                const destination = $scope.service.video.favorite.added ? $scope.service.video.favorite.remove : $scope.service.video.favorite.add;

                await $http.post(destination, params);

                $scope.service.video.favorite.added = !$scope.service.video.favorite.added;
            } finally {
                $scope.loading = false;
            }
        },
        suggestPornstars: {
            response: null,
            status: null,
            focused: false,
            selected: [],
            select: function(item) {
                item.checked = true;
                let exists = false;
                angular.forEach(this.selected, function (value) {
                    if ( item.id === value.id ) {
                        exists = true;
                    }
                });
                if(exists === false && this.selected.indexOf(item) === -1) {
                    this.selected.push(item);
                }
            },
            deselect: function(item) {
                let index = this.selected.indexOf(item);
                angular.forEach(this.selected, function (value) {
                     if ( item.id === value.id ) {
                         value.checked = false;
                     }
                });
                if(index !== -1) {
                    this.selected.splice(index, 1);
                }
            },
            display: function() {
                if ($scope.service.user.guest === true ) {
                    window.location = $scope.service.video.playlists.signup;
                } else {
                    $modules.show('suggestPornstars');
                }
            },
            blur: function() {
                this.focused = true;
            },
            submit: function() {
                let ids = [];
                this.selected.forEach(function(item){
                    ids.push(item.id);
                });

                if(ids.length > 0) {
                    $http({
                        method : 'POST',
                        url: $scope.service.video.pornstars.suggest,
                        data: $httpParamSerializerJQLike({ ids: ids }),
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                    }).then((response) => {
                        this.status = response.data;
                        $scope.searchActors.results = {};
                        this.selected = [];
                    });
                }
            }
        },
        playlists: {
            name: null,
            response: false,
            loading: false,
            async display() {
                console.log("???");
                if ($scope.service.video.playlists.available === false) {
                    $rootScope.showLoginPopup = true;
                    $rootScope.loadLoginPopup = true;
                    return;
                }

                const response = await $http.get($scope.service.video.playlists.display)
                if (response.data.success) {
                    $scope.service.video.playlists.items = response.data.items;
                    $modules.show('playlists');
                }
            },
            async create() {
                const data = {
                    [$scope.service.video.csrfToken.name]: $scope.service.video.csrfToken.value,
                    name: this.name,
                    movie_id: $scope.service.video.id,
                };

                const response = await $http.post($scope.service.video.playlists.create, data);
                if (response.data.success) {
                    $scope.service.video.playlists.items = response.data.items;
                    this.name = null;
                }
                this.response = response.data;
            },
            async toggle(playlist) {
                const data = {
                    [$scope.service.video.csrfToken.name]: $scope.service.video.csrfToken.value,
                    movie_id: $scope.service.video.id,
                    playlist_id: playlist.playlist_id,
                };
                const destination = playlist.has_movie ? $scope.service.video.playlists.add : $scope.service.video.playlists.remove;

                const response = await $http.post(destination, data);
                this.response = response.data;
            }
        },
        report: {
            reason: null,
            comment: null,
            loading: false,
            message: null,
            success: false,
            submit: () => {
                $scope.actions.report.loading = true;
                $http({
                    method : 'POST',
                    url: $scope.service.video.report.action,
                    data: $httpParamSerializerJQLike({
                        reason:  $scope.actions.report.reason,
                        comment:  $scope.actions.report.comment,
                    }),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then((response) => {
                    $scope.actions.report.loading = false;
                    $scope.actions.report.message = response.data.service.message;
                    $scope.actions.report.success = response.data.success;
                    $scope.actions.report.error = response.data.error;

                });
            },
            close() {
                $scope.actions.report.reason = null;
                $scope.actions.report.comment = null;
                $scope.actions.report.message = null;
                $scope.actions.report.success = false;
                $scope.actions.report.error = false;
                $scope.modules.display.playerReport = false;
                $modules.hide('playerReport');
            },
            display() {
                if ($scope.service.user.guest === true ) {
                    $rootScope.loadLoginPopup = true;
                    $rootScope.showLoginPopup = true;
                    return false;
                } else {
                    $modules.show('playerReport');
                }
            }
        }

    };

}];

export default VideosController;
